import { Component, Input, OnInit } from "@angular/core";
import { AbstractControl } from "@angular/forms";

@Component({
    selector: "[print-error]",
    templateUrl: "./print-error.component.html",
    styleUrls: ["./print-error.component.scss"],
    standalone: false
})
export class PrintErrorComponent implements OnInit {
    @Input() fieldName = "This field";
    @Input() control?: AbstractControl;

    constructor() {}

    ngOnInit() {}
}
